import { axiosClient } from "../axios";
import { getQuery } from "../helper";

const baseUrl = "/api/notifications";

export function getAll(page = 1, pageSize = 20, unreadOnly = false) {
  return axiosClient.get(baseUrl, getQuery({ page, pageSize, unreadOnly }));
}

export function getUnreadCount() {
  return axiosClient.get(`${baseUrl}/unread-count`);
}

export function markAsRead(notificationId) {
  return axiosClient.post(`${baseUrl}/${notificationId}/read`);
}

export function markAllAsRead() {
  return axiosClient.post(`${baseUrl}/read-all`);
}
